module.exports = __webpack_public_path__ + "static/img/3_3_1.c9228e04.jpg";